/**
 * Created by shiyonggao on 2019/2/25.
 */

/**
 * state 中的方法命名规则（小驼峰规则）
 */
const state = {
    data: {},
    users: [],
    detailData: {}
};

/**
 * actions 中的方法命名规则（外部调用和内部调用）
 * 内部规则：_demo
 * 外部调用：DEMO
 */
const actions = {
    create({ commit, dispatch, rootState }, args) {
        let URL = rootState.$config.api.push_plans_news;
        URL = URL.replace('{game_code}', rootState.$activeGameCode);
        return rootState.$helper.request.put(URL, args)
            .then((res) => {
                commit('updateData', res.data.created);
                return res.data;
            });
    },
    getPlansTimeList({ dispatch, rootState }, args) {
        let URL = rootState.$config.api.push_get_plans_times;
        return rootState.$helper.request.get(URL, {...args})
            .then((res) => {
                return res.data;
            })
            .catch((res) => {
                dispatch('ERROR_HANDLE', res, {root: true});
            });
    },
    getPlatformConfig({ dispatch, rootState }, platForm) {
        let URL = rootState.$config.api.push_get_os_platform_config;
        return rootState.$helper.request.get(URL, {platform: platForm})
            .then((res) => {
                return res.data;
            })
            .catch((res) => {
                dispatch('ERROR_HANDLE', res, {root: true});
            });
    },
    getAllUsers({ commit, dispatch, rootState }, args) {
        let URL = rootState.$config.api.push_get_all_users;
        return rootState.$helper.request.get(URL, {...args})
            .then((res) => {
                commit('updateUsers', res.data.list);
                return true;
            })
            .catch((res) => {
                dispatch('ERROR_HANDLE', res, {root: true});
            });
    },
    getDetail({ commit, dispatch, rootState }, args) {
        let URL = rootState.$config.api.push_get_plans_detail;
        commit("PRIVATE_LOADING", true, { root: true });
        return rootState.$helper.request.get(URL, {...args})
            .then((res) => {
                commit('updateData', res.data.list[0]);
                commit('updateDetailData',  res.data.list[0]);
                commit("PRIVATE_LOADING", false, { root: true });
                return true;
            })
            .catch((res) => {
                dispatch('ERROR_HANDLE', res, {root: true});
                commit("PRIVATE_LOADING", false, { root: true });
            });
    },
};

/**
 * mutations 中的方法命名规则（外部调用和内部调用）
 * 内部规则：_demo
 * 外部调用：DEMO
 * 描述：建议不对外提供映射关系
 */
const mutations = {
    updateData(state, data) {
        state.data = data;
    },
    updateDetailData(state, data) {
        state.detailData = data;
    },
    updateUsers(state, data) {
        state.users = data;
    },
};

export default {
    namespaced: true,
    state,
    actions,
    mutations
};



// WEBPACK FOOTER //
// ./website/store/modules/push/PushPlanOperate.js